export const showPopupSnackbar = message => {
	return { type: "SNACKBAR_POPUP", message };
  };
  
  export const clearSnackbar = () => {
	return { type: "SNACKBAR_CLEAR" };
  };